<div class="modal-container">
  <div class="modal-header">
    <h4 class="modal-title">{{ data.data.title }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  @if (!data.data.error) {
    <div class="modal-body">
      @if (data.data.videoHostingService === videoHost.YOUTUBE) {
        <iframe
          title="product video"
          width="640"
          height="385"
          [src]="data.data.videoURL"
          allowfullscreen
          >
          Video is loading</iframe
          >
        }
      </div>
    }
    @if (data.data.error) {
      <div class="modal-body modal-body--error">
        <p><cx-icon [type]="iconType.WARNING"></cx-icon> {{ data.data.error }}</p>
      </div>
    }
  </div>
